module.exports = __webpack_public_path__ + "media/images/athletes/3695-5730bdadc316f56de44a0e79618f307c.png";